import React from 'react'
import { NavLink } from 'react-router-dom'
import Container from '@mui/material/Container';

import { styled } from '@mui/styles';

 import { makeStyles } from 'tss-react/mui'; // if you still want to use makeStyles

import mainStyle from "../assets/mainStyle";
const useStyles = makeStyles()((theme) => ({
    
      colouredButton: {
        backgroundColor:"#19A78E",
        fontSize: "16px;",
        color: "#fff;",
        fontWeight: "700;",
        textDecoration: "none",
        padding: "13px;",
        borderRadius: "50px;",
        "&:hover":{
            backgroundColor:"#374657",
        }
      },

      clearButton: {
        fontSize: "16px;",
        color: "#374657;",
        fontWeight: "700;",
        textDecoration: "none"
      },
      Center:{
        textAlign: "center;"
      },
    root:{
        textAlign: "center;",
        paddingTop: "20px;",
        marginBottom: "100px;",
    }
}));

const Maintenance = () => {
    const { classes } = useStyles();

    return (
            <Container className={classes.root}>
                <h1><strong>Under Maintenance.</strong></h1>
            </Container>
        )
}
export default Maintenance
